<template>
  <v-container id="stats" tag="section">
    <!-- <base-v-component heading="Estadísticas " />
    <base-material-card
      color="indigo"
      icon="mdi-chart-areaspline"
      inline
      class="px-5 py-3"
    >
      <template> </template>
    </base-material-card> -->
      <estadisticas-componente />
  </v-container>
</template>

<script>
import EstadisticasComponente from "../../components/EstadisticasComponente.vue";

export default {
  components: { EstadisticasComponente },
  data() {
    return {};
  },
};
</script>

<style>
</style>